import classNames from "classnames";

import "./style.scss";

interface ButtonProps {
	label: string | React.ReactNode;
	onClick?: () => void;
	color?: "white" | "black";
	className?: string;
	size?: "small" | "medium" | "large";
	type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
	disabled?: boolean;
}

const Button = ({
	className,
	label,
	onClick,
	color = "white",
	size = "medium",
	type = "button",
	disabled = false,
}: ButtonProps) => {
	return (
		<button
			className={classNames("button-wrapper", {
				[className as string]: className,
				[color]: color,
				[size as string]: size,
			})}
			disabled={disabled}
			onClick={onClick}
			type={type}
		>
			{label}
		</button>
	);
};

export default Button;
